import React from 'react';

import { ExternalUrlDescription } from '@/graphql/generated';
import { useUserTrackingConsent } from '@/hooks';

import { LoadingPlaceholder } from '../loading-placeholder';
import { NoConsentExternalURLMessage } from './components/no-consent';
import { ExternalURLDescriptionComponent } from './external-url-description-component';

interface Props {
  description: ExternalUrlDescription;
}

const ExternalUrlDescriptionContainer: React.FC<Props> = ({ description }) => {
  const { loading, hasTrackingConsent } = useUserTrackingConsent();

  if (loading) return <LoadingPlaceholder testId="external-url-description-loading" />;

  return hasTrackingConsent ? (
    <ExternalURLDescriptionComponent description={description} />
  ) : (
    <NoConsentExternalURLMessage description={description} />
  );
};

export default ExternalUrlDescriptionContainer;
